import { api } from './api';

export interface SceneGenerationRequest {
  assetIds: string[];
  primaryPrompt: string;
  styleModifiers?: string[];
  negativePrompt?: string;
  aspectRatio?: string;
  variationsCount?: number;
}

export interface SceneScaperMockup {
  mockupId: string;
  mockupUrl: string;
  name: string;
  variationNumber: number;
}

export interface SceneGenerationResponse {
  mockupId?: string;
  mockupUrl?: string;
  mockups: SceneScaperMockup[];
  creditsUsed: number;
  creditsRemaining: number;
  variationsRequested?: number;
  variationsCompleted?: number;
  message?: string;
}

class SceneScaperService {

  async generateScene(request: SceneGenerationRequest): Promise<SceneGenerationResponse> {
    try {
      const response = await api.post('/api/v1/scenes/generate', request);
      return response.data;
    } catch (error: any) {
      if (error.response) {
        if (error.response.status === 403) {
          throw new Error('SceneScaper AI requires a Professional or Agency license');
        }
        if (error.response.status === 402) {
          throw new Error(error.response.data?.message || 'Insufficient credits to generate the requested scenes.');
        }
        throw new Error(error.response.data?.message || `Failed to generate scene: ${error.response.statusText}`);
      }
      if (error.message) {
        throw error;
      }
      throw new Error('Failed to connect to the server. Please try again.');
    }
  }

  async checkCredits(): Promise<{ credits: number; canGenerate: boolean }> {
    try {
      const response = await api.get('/api/v1/scenes/check-credits');
      return {
        credits: response.data.credits,
        canGenerate: response.data.credits >= 2,
      };
    } catch (error) {
      console.error('Error checking credits:', error);
      return { credits: 0, canGenerate: false };
    }
  }
}

export const sceneScaperService = new SceneScaperService();
